import React from 'react';
import type ChatSocket from './ChatSocket';

export enum SocketStatus {
  Connecting = 'Connecting',
  Connected = 'Connected',
  Closed = 'Closed',
  Failed = 'Failed',
}

interface SocketContextValue {
  socket: ChatSocket | null;
  status: SocketStatus;
  connectionId: string;
  reConnect: (force?: boolean) => void;
}

export const SocketContext = React.createContext<SocketContextValue>({} as SocketContextValue);

export const useSocketContext = (): SocketContextValue => React.useContext(SocketContext);
